import { useRouter } from 'next/router';
import { AGENT_BUILDER_ROUTE, INVESTIGATION_ROUTE, PLAYBOOK_ROUTE } from '@/config/constants';

// Routes that always start with the main nav collapsed, regardless of the user's saved
// preference — the builders and investigation details need the horizontal room for their
// dense UI plus the docked Percy chat. Derived from the route and read live (never written
// to the persisted collapse store), so FullLayout can force collapse for the visit without
// leaking the choice onto other routes. Mirrors useChatWidgetLockedFullscreen.
const FORCE_COLLAPSE_ROUTES: string[] = [INVESTIGATION_ROUTE, PLAYBOOK_ROUTE, '/playbooks/new', AGENT_BUILDER_ROUTE, '/agents/builder', '/developers/appearance/[id]'];
const useForceNavCollapsed = () => {
  return FORCE_COLLAPSE_ROUTES.includes(useRouter().pathname);
};
export default useForceNavCollapsed;